import styled from 'styled-components'
import InputMask from 'react-input-mask'
import { Form } from 'react-bootstrap'

export const StyledInput = styled.input`
    width: 100%;
    border: 1px solid #DDDDDD;
    padding: 10px;
`
export const StyledInputMask = styled(InputMask)`
    width: 100%;
    border: 1px solid #DDDDDD;
    padding: 10px;
`
export const StyledTitle = styled.h1`
    font-size: 3em;
    font-weight: bold;
    text-transform: uppercase;
`

export const StyledSubtitle = styled.h2`
    font-size: 2em;
`
export const StyledError = styled.p`
    margin: 0px;
    color: red;
    font-size: 80%;
    position: absolute;
    bottom: -40%;
`
export const StyledCheck = styled(Form.Check)`
    display: flex;
    flex-direction: row;
    align-items: center;
    label {
        font-size: 2em;
        @media screen and (max-width: 768px) {
         font-size: 1em;   
        }
    }
    input {
        position: relative;
        bottom: 2px;
        margin-right: 3px;
        &[type='radio'] {    
            height: 20px;
            width: 20px;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            border-radius: 100%;
            padding: 2px;
            background-clip: content-box;
            border: 1px solid #000;
            @media screen and (max-width: 768px) {
                width: 15px;   
                height: 15px;   
            }
            &:checked {
                background-color: red;
            }
        }
    }
`